"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var title = (0, _glamor.css)(_fonts.subH2, {
  textTransform: "uppercase",
  lineSpacing: "normal",
  fontWeight: 700,
  color: _css.colors.white
}, (0, _polyfluid.polyfluid)({
  letterSpacing: {
    small: [0, -0.025],
    medium: [-0.025],
    large: [-0.025, -0.085]
  },
  fontSize: {
    small: [1.125, 1.5],
    medium: [1.125, 1.5],
    large: [1.5, 1.5]
  }
}));

var radioGroup = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(2)
});

var footnote = (0, _glamor.css)(_fonts.p4, {
  color: _css.colors.gray,
  lineHeight: 1.5,
  marginTop: (0, _css.unitRem)(1.5),
  marginBottom: (0, _css.unitRem)(1.5)
});

var note = (0, _glamor.css)(footnote, {
  display: "block",
  color: _css.colors.gray,
  marginTop: (0, _css.unitRem)(1.5),
  marginBottom: (0, _css.unitRem)(1.5)
});

var sec = (0, _glamor.css)((0, _polyfluid.polyfluid)({
  paddingTop: {
    smallMedium: 2.25,
    large: [2.25, 3]
  },
  paddingBottom: {
    smallMedium: 2.25,
    large: [2.25, 3]
  }
}));

var checkboxLabel = (0, _glamor.css)({
  display: "flex",

  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px",
  color: "rgba(255, 255, 255, 0.5)",

  "& > span": {
    position: "relative",
    top: "-1px"
  },
  "& a": {
    color: "#2b98f0",
    textDecoration: "none",
    transition: "box-shadow 0.2s, color 0.2s ease-in-out"
  },
  "& a:hover": {
    color: "#ffffff"
  }
});

var linkStyle = (0, _glamor.css)({
  color: "#2b98f0",
  textDecoration: "none",
  transition: "box-shadow 0.2s, color 0.2s ease-in-out",
  "& :hover": {
    color: "#ffffff"
  }
});

var ChoiceLicence = function ChoiceLicence(props) {
  return _react2.default.createElement(
    "section",
    null,
    _react2.default.createElement(
      "div",
      { className: sec },
      _react2.default.createElement(
        "h1",
        { className: title },
        props.title
      ),
      props.note && _react2.default.createElement("small", {
        className: note,
        dangerouslySetInnerHTML: { __html: props.note }
      }),
      props.footnote && _react2.default.createElement("small", {
        className: note,
        dangerouslySetInnerHTML: { __html: props.footnote }
      })
    )
  );
};

exports.default = ChoiceLicence;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChoiceLicence/ChoiceLicence.jsx
// module id = 2864
// module chunks = 0